/** En-tête de page avec titre */

interface HeaderProps {
  title: string;
  action?: React.ReactNode;
}

export function Header({ title, action }: HeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">
      <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
      {action && <div className="flex flex-wrap gap-2">{action}</div>}
    </div>
  );
}
